// Diagnostic events only. VAST impression/quartile billing beacons stay separate.
const LIMIT = 20;
let queue = [];
let timer = null;
let listening = false;

export function flushRuntimeEvents() {
  if (timer !== null) clearTimeout(timer);
  timer = null;
  if (!queue.length) return;
  const body = JSON.stringify({ events: queue.splice(0, LIMIT) });
  try {
    if (typeof navigator !== 'undefined' && navigator.sendBeacon?.('/api/ads/runtime-event', new Blob([body], { type: 'application/json' }))) return;
  } catch (_) {}
  try {
    fetch('/api/ads/runtime-event', {
      method: 'POST', headers: { 'content-type': 'application/json' },
      body, keepalive: true, cache: 'no-store',
    }).catch(() => {});
  } catch (_) {}
}

export function reportRuntimeEvent(detail = {}) {
  if (typeof window === 'undefined' || detail.event === 'progress') return;
  if (!listening) {
    window.addEventListener('pagehide', flushRuntimeEvents);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') flushRuntimeEvents();
    });
    listening = true;
  }
  const match = String(window.location?.pathname || '').match(/^\/watch\/([^/?#]+)/i);
  let titleId = match?.[1] || '';
  try { titleId = decodeURIComponent(titleId); } catch (_) {}
  queue.push({
    event: String(detail.event || detail.phase || 'state').slice(0, 40),
    phase: String(detail.phase || '').slice(0, 40),
    source: String(detail.tagSource || 'unknown').slice(0, 40),
    position: String(detail.position || '').slice(0, 20),
    slotId: String(detail.slotId || '').slice(0, 60),
    code: String(detail.code || '').slice(0, 80),
    innerCode: String(detail.innerCode || '').replace(/[^0-9-]/g, '').slice(0, 12),
    titleId: titleId.slice(0, 160),
    occurredAt: new Date().toISOString(),
  });
  if (queue.length >= LIMIT) flushRuntimeEvents();
  else if (timer === null) timer = setTimeout(flushRuntimeEvents, 5000);
}
